import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01e1e0f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row headers" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-2 text-center" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Include?")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-8" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Name")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, [
    /*#__PURE__*/_createElementVNode("p", null, "State")
  ])
], -1))
const _hoisted_2 = { class: "col-2 text-center" }
const _hoisted_3 = ["onChange", "checked"]
const _hoisted_4 = { class: "col-8" }
const _hoisted_5 = { class: "col-2" }
const _hoisted_6 = { class: "form-check form-switch" }
const _hoisted_7 = ["disabled", "onChange", "checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row",
        key: index
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("input", {
            type: "checkbox",
            onChange: ($event: any) => (_ctx.onIncludedChanged(item.id)),
            checked: item.isIncluded
          }, null, 40, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", null, _toDisplayString(item.name), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("input", {
              class: "form-check-input form-switch-lg",
              type: "checkbox",
              disabled: !item.isIncluded,
              onChange: ($event: any) => (_ctx.onEnabledChanged(item.id)),
              checked: item.isEnabled
            }, null, 40, _hoisted_7)
          ])
        ])
      ]))
    }), 128))
  ], 64))
}